export default "__VITE_ASSET__s_a3_9Ei__"